import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorStatus } from '@core/enums';
import { ComparisonUtil } from '@core/utils';
import { Observable, throwError } from 'rxjs';

/** Type of the handleError function returned by HttpErrorHandler.createHandleError */
export type HandleError = <T>(operation?: string, result?: T) => (error: HttpErrorResponse) => Observable<T>;

/** Handles HttpClient errors */
@Injectable({
  providedIn: 'root',
})
export class HttpErrorHandler {
  /** Create curried handleError function that already knows the service name */
  createHandleError =
    (serviceName = '') =>
    <T>(operation = 'operation', result = {} as T) =>
      this.handleError(serviceName, operation, result);

  /**
   * Returns a function that handles Http operation failures.
   * This error handler lets the app continue to run as if no error occurred.
   * @param serviceName = name of the data service that attempted the operation
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  //serviceName = '', operation = 'operation', result = {} as T
  handleError<T>(serviceName = '', operation = 'operation', result = {} as T) {
    return (error: HttpErrorResponse): Observable<T> => {
      // TODO: send the error to remote logging infrastructure

      const message =
        error.error instanceof ErrorEvent
          ? error.error.message
          : `server returned code ${error.status} with body "${error.error}"`;

      console.error(
        `${serviceName}, ${operation} ${ComparisonUtil.isObjectEmpty(result) ? '' : result}, error: ${message}`,
      );

      if (error.status == ErrorStatus.TechnicalError) {
        this.handle500Error(error);
      }

      if (
        error.status == ErrorStatus.Forbidden ||
        error.status == ErrorStatus.Unauthorized ||
        error.status == 0 /*CORS Error*/
      ) {
        this.handleSecurityError(error);
      }

      // TODO: better job of transforming error for user consumption
      /*             this.loggingService.error(
                            `${operation} failed: ${message}`,
                            serviceName
                        ); */

      // Let the app keep running by returning a safe result.
      return throwError(() => new Error(error?.message));
    };
  }
  //, operation = ''
  private handle500Error = (error: HttpErrorResponse) => {
    console.error(error);
  };

  private handleSecurityError(error: HttpErrorResponse): void {
    console.error(error);
  }
}
